import {parseISO} from "date-fns";
import GeoService from "../services/geo";

export const requestMapper = (data) => {
    return {
        id: data.id,
        incrementalNumber: data.incrementalNumber,
        name: data.name,
        surname: data.surname,
        email: data.email,
        arrival: parseISO(data.arrival),
        departure: parseISO(data.departure),
        adults: data.adults,
        children: data.children,
        childrensAge: data.childrensAge,
        petsNumber: data.petsNumber,
        content: data.content,
        nationality: GeoService.COUNTRIES.find(c => c.code === data.nationality),
        language: data.language,
        sendTime: parseISO(data.sendTime)
    }
}
